const Smile = ({ color, type }) => {
  const solid = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5024 22C18.0164 22 22.5024 17.514 22.5024 12C22.5024 6.486 18.0164 2 12.5024 2C6.98844 2 2.50244 6.486 2.50244 12C2.50244 17.514 6.98844 22 12.5024 22ZM15.9954 9C16.1948 8.99491 16.3932 9.02979 16.5789 9.10259C16.7646 9.17539 16.9338 9.28463 17.0766 9.42387C17.2194 9.56311 17.3329 9.72954 17.4103 9.91333C17.4878 10.0971 17.5277 10.2946 17.5276 10.494C17.5275 10.6935 17.4875 10.8909 17.4099 11.0746C17.3324 11.2584 17.2188 11.4247 17.0759 11.5639C16.933 11.703 16.7637 11.8121 16.578 11.8848C16.3922 11.9575 16.1938 11.9922 15.9944 11.987C15.605 11.9768 15.235 11.8149 14.9632 11.5358C14.6915 11.2567 14.5395 10.8826 14.5396 10.493C14.5397 10.1035 14.692 9.72939 14.9639 9.45049C15.2359 9.1716 15.606 9.00995 15.9954 9ZM11.6944 15.919C12.2278 16.026 12.7771 16.026 13.3104 15.919C13.5634 15.867 13.8154 15.788 14.0604 15.686C14.2944 15.586 14.5244 15.462 14.7394 15.318C14.9474 15.176 15.1464 15.012 15.3304 14.829C15.5134 14.647 15.6774 14.448 15.8194 14.237L17.4774 15.354C17.0464 15.9929 16.4968 16.5432 15.8584 16.975C15.2081 17.4139 14.478 17.721 13.7094 17.879C12.9127 18.0391 12.0921 18.0387 11.2954 17.878C10.5267 17.7223 9.79654 17.4154 9.14744 16.975C8.50909 16.5421 7.95896 15.9916 7.52644 15.353L9.18444 14.236C9.32744 14.447 9.49144 14.646 9.67244 14.826C10.2246 15.3809 10.9278 15.761 11.6944 15.919ZM9.00244 9C9.19949 9.00007 9.3946 9.03894 9.57662 9.11441C9.75865 9.18988 9.92402 9.30046 10.0633 9.43984C10.2026 9.57922 10.3131 9.74467 10.3884 9.92675C10.4638 10.1088 10.5025 10.304 10.5024 10.501C10.5024 10.698 10.4635 10.8932 10.388 11.0752C10.3126 11.2572 10.202 11.4226 10.0626 11.5619C9.92322 11.7012 9.75777 11.8116 9.5757 11.887C9.39362 11.9623 9.19849 12.0011 9.00144 12.001C8.60348 12.0009 8.22188 11.8427 7.94057 11.5612C7.65927 11.2797 7.50131 10.898 7.50144 10.5C7.50157 10.102 7.65979 9.72044 7.94128 9.43913C8.22277 9.15783 8.60448 8.99987 9.00244 9Z"
        fill={color}
      />
    </svg>
  );

  const regular = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5024 2C6.98844 2 2.50244 6.486 2.50244 12C2.50244 17.514 6.98844 22 12.5024 22C18.0164 22 22.5024 17.514 22.5024 12C22.5024 6.486 18.0164 2 12.5024 2ZM12.5024 20C8.09144 20 4.50244 16.411 4.50244 12C4.50244 7.589 8.09144 4 12.5024 4C16.9134 4 20.5024 7.589 20.5024 12C20.5024 16.411 16.9134 20 12.5024 20Z"
        fill={color}
      />
      <path
        d="M15.3314 14.828C14.9658 15.1923 14.5341 15.4835 14.0594 15.686C13.2047 16.0468 12.2511 16.0995 11.3619 15.835C10.4727 15.5705 9.70293 15.0053 9.18437 14.236L7.52637 15.355C7.9588 15.9931 8.50896 16.543 9.14737 16.975C9.79702 17.4143 10.527 17.7212 11.2954 17.878C12.0922 18.0405 12.9136 18.0405 13.7104 17.878C14.4787 17.7209 15.2086 17.4141 15.8584 16.975C16.1714 16.763 16.4704 16.517 16.7444 16.244C17.0164 15.973 17.2644 15.673 17.4784 15.355L15.8204 14.236C15.6766 14.4485 15.5129 14.6467 15.3314 14.828Z"
        fill={color}
      />
      <path
        d="M9.00244 12C9.83087 12 10.5024 11.3284 10.5024 10.5C10.5024 9.67157 9.83087 9 9.00244 9C8.17401 9 7.50244 9.67157 7.50244 10.5C7.50244 11.3284 8.17401 12 9.00244 12Z"
        fill={color}
      />
      <path
        d="M15.9954 11.986C16.82 11.986 17.4884 11.3176 17.4884 10.493C17.4884 9.66844 16.82 9 15.9954 9C15.1709 9 14.5024 9.66844 14.5024 10.493C14.5024 11.3176 15.1709 11.986 15.9954 11.986Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Smile;
